import { MenuItem } from './Item';
import { MenuRoot } from './Root';

export const MenuFilters = {
  Root: MenuRoot,
  Item: MenuItem,
};
